import { takeEvery } from "@redux-saga/core/effects";
import { notification } from "antd";
import { AxiosError } from "axios";
import { call, put, takeLatest } from "redux-saga/effects";

import { IUser } from "../../../Models/Models";
import * as actions from "../Actions/UserActions";
import * as api from "../API/UserApi";
import * as types from "../Types/UserActionTypes";

export function* watchUserSagas() {
    yield takeEvery(types.GET_USER_INIT, getUser);
    /** GB:
     * takeLatest used here because it's possible a user could spam this action by opening / closing
     * the menu that would make this call.
     */
    yield takeLatest(types.GET_ALL_USERS_INIT, getAllUsers);
}

export function* getUser() {
    try {
        const user: IUser = yield call(() => api.getUser());
        yield put(actions.getUserSuccess(user));
    } catch (e) {
        notification.error({
            message: "Error getting user",
            description: e,
        });
        yield put(actions.getUserFailure(e));
    }
}

export function* getAllUsers() {
    try {
        yield put(actions.setLoadingAllUsers(true));
        const users: IUser[] = yield call(() => api.getAllUsers());
        yield put(actions.getAllUsersSuccess(users));
    } catch (e) {
        const err: AxiosError = e;
        notification.error({
            message: "Error getting all users",
            description: err.message,
        });
        yield put(actions.getAllUsersFailure(err.message));
    } finally {
        yield put(actions.setLoadingAllUsers(false));
    }
}